import { useState, useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import ReactPlayer from "react-player/youtube";
import { STATIC_IMAGES } from "../helpers/staticImages";

type RpVideoPlayerProps = {
  url?: string;
  videoThumbnail?: string;
  showPlayIcon?: boolean;
  loaderTimeout?: number;
  [key: string]: unknown;
};

const YouTubePlayer = ReactPlayer as React.ElementType;

export default function RpVideoPlayer({
  url,
  videoThumbnail = STATIC_IMAGES.videoThumbnail,
  showPlayIcon = false,
  loaderTimeout = 2000, // Set the desired duration for the loader (in milliseconds)
  ...rest
}: RpVideoPlayerProps) {
  const [loading, setLoading] = useState(true);
  const [play, setPlay] = useState(false);

  useEffect(() => {
    // Start the video after the loaderTimeout duration
    const timer = setTimeout(() => {
      setLoading(false);
      setPlay(true);
    }, loaderTimeout);

    return () => clearTimeout(timer);
  }, [loaderTimeout]);

  return (
    <div className="player-wrapper d-flex align-items-center justify-content-center">
      {loading ? (
        <div className="player-loader position-absolute">
          <CircularProgress color="primary" />
        </div>
      ) : (
        <YouTubePlayer
          className="react-player"
          width="100%"
          height="100%"
          playing={play}
          url={url}
          light={videoThumbnail}
          playIcon={showPlayIcon ? null : <span></span>}
          controls
          {...rest}
        />
      )}
    </div>
  );
}
